import { render } from "./General.vue?vue&type=template&id=815203c2&ts=true"
import script from "./General.vue?vue&type=script&lang=ts"
export * from "./General.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Users\\orson\\coding\\thelounge\\thelounge\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/Settings/General.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "815203c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('815203c2', __exports__)) {
    api.reload('815203c2', __exports__)
  }
  
  module.hot.accept("./General.vue?vue&type=template&id=815203c2&ts=true", () => {
    api.rerender('815203c2', render)
  })

}


export default __exports__